// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"936":"cd696828","8246":"fd2abe8b"}[chunkId] + ".chunk.css";
};